<!--
Considera pedidos de venda válidos (aberto ou faturado) agrupado por clientes
Permite vários periodos


FALTANDO EXCEL
FALTANDO ORDERNACAO PELAS COLUNAS (CLICAR E RECARREGAR OS DADOS CONFORME COLUNA SELECIONADA)

-->


<template>
  <div class="container-full-width default-container p-3">
    <filtro 
      :showfiltro="showfiltro" 
      :params="paramsFiltro" 
      @change="filtroChange" 
      @cancel="filtroCancel"
    />
    <div class="row">
      <div class="col-12 mb-2">
          <span class="lbl-deal-title mb-2 w-100">VENDAS POR CLIENTE</span>
          <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
      </div>
    </div>
    <hr />
    <div class="row mb-3 align-items-center">
      <div class="col-md-6 col-12">
        <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
      </div>
    </div>

    <div class="row" v-if="chartValues.length > 0">
      <div class="col-md-12 col-12 p-3">
        <div class="lbl-title mb-2">Gráfico</div>
        <div class="border">
          <chart :params="paramsChart"></chart>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-12 lbl-title mb-2">
        CLIENTES
        <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button>
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12" v-if="produtos.length == 0">
        Nenhum cliente encontrado
      </div>
      <div class="col-12" v-else>
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px" >
          <div style="overflow: auto">
            <table class="table table-striped table-hover responsive tablesorter w-100">
                <thead>
                    <tr>
                        <th colspan="1" style="border: none"></th>
                        <th v-for="(periodo, index) in dados.periodos" :key="index" :colspan="colSpan(index)" class="text-center" style="border-bottom: none; border-left: 1px solid #dee2e6; border-right: 1px solid #dee2e6;">
                            <span>{{ periodo.label }}</span>
                        </th>
                    </tr>
                    <tr>
                      <template v-for="col in colunas">
                        <th v-if="col.visible" :class="col.class" :style="col.style">{{ col.label }}</th>
                      </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in produtos" :key="index">
                        <td class="textual">{{ row.nome_cliente }}</td>
                        <template v-for="item in dados.periodos">
                            <td class="numerico size130" style="border-left: 1px solid #dee2e6;">{{ row[item.nome].qt_produtos_diferentes }}</td>
                            <td class="numerico size130">{{ row[item.nome].valor | formatValue(2) }}</td>
                            <!-- <td class="numerico size130">{{ row[item.nome].participacao_qt_produtos_diferentes | formatValue(2) }}%</td> -->
                            <td class="numerico size130">{{ row[item.nome].participacao_valor | formatValue(2) }}%</td>
                            <!-- <td v-if="item.agrupamento > 1" class="numerico size130"><span class="var" :class="varColor(row[item.nome].variacao_qt_produtos_diferentes)">{{ row[item.nome].variacao_qt_produtos_diferentes | formatValue(2) }}%</span></td> -->
                            <td v-if="item.agrupamento > 1" class="numerico size130"><span class="var" :class="varColor(row[item.nome].variacao_valor)">{{ row[item.nome].variacao_valor | formatValue(2) }}%</span></td>
                        </template>
                        <td class="numerico" style="border-left: 1px solid #dee2e6;">{{ row.valor | formatValue(2) }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th class="text-right total">Total</th>
                        <template v-for="item in dados.periodos">
                            <th class="numerico size130 total" style="border-left: 1px solid #dee2e6;">{{ dados.total[item.nome].qt_produtos_diferentes }}</th>
                            <th class="numerico size130 total">{{ dados.total[item.nome].valor | formatValue(2) }}</th>
                            <!-- <th class="numerico size130 total"></th> -->
                            <th class="numerico size130 total"></th>
                            <!-- <th v-if="item.agrupamento > 1" class="numerico size130 total"><span class="var" :class="varColor(dados.total[item.nome].variacao_qt_produtos_diferentes)">{{ dados.total[item.nome].variacao_qt_produtos_diferentes | formatValue(2) }}%</span></th> -->
                            <th v-if="item.agrupamento > 1" class="numerico size130 total"><span class="var" :class="varColor(dados.total[item.nome].variacao_valor)">{{ dados.total[item.nome].variacao_valor | formatValue(2) }}%</span></th>
                        </template>
                        <th class="numerico total" style="border-left: 1px solid #dee2e6;">{{ dados.total.valor | formatValue(2) }}</th>
                    </tr>
                </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashCard from "../dashboards/dash-card";
import Chart from "./chart";
import Filtro from "./filtro";
import { apiORDSpost } from "../shared/api-functions";
import { apiDownload2 } from "../shared/api-functions";

export default {
  components: {
    DashCard,
    Filtro,
    Chart,
  },

  data() {
    return {
      showfiltro: false,

      dados: {},

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        periodo: {
          label: "Data da venda",
          varios: true,
          data_inicio: null,
          data_termino: null,
        },

        filtros: [
          { 
            nome: "filial", 
            label: null, 
            url: null, 
            varios: false, 
            values: [] 
            },
          {
            nome: "segmento",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          {
            nome: "grupocliente",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          { 
            nome: "estado", 
            label: null, 
            url: null, 
            varios: true, 
            values: [] 
            },
          {
            nome: "grupoestoque",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          {
            nome: "produto",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
        ],
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }],
      },


      colunas: [
      ],

      mounting: false,

    };
  },

  watch: {},

  methods: {
    clickRetornar () {
        this.$router.push('/')
    },

    varColor (val) {
        return { 'var-negative': val < 0, 'var-positive': val >= 0, '': val == 0}
    },

    colSpan (index) {
        if (index > 0)
            return 4
        else
            return 3
    },

    montaColunas () {
        this.colunas = [
            { nome: 'nome_cliente', visible: true, label: 'Cliente', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' },
            { nome: 'id', visible: false, label: 'Código' },
            { nome: 'uf', visible: false, label: 'Estado' },
            { nome: 'grupo_cliente', visible: false, label: 'Grupo de Cliente' },
            { nome: 'segmento', visible: false, label: 'Segmento' },
            { nome: 'telefone', visible: false, label: 'Telefone' },
            { nome: 'email', visible: false, label: 'Email' },
        ]

        let base = [
            { nome: 'quantidade', visible: true, label: 'Quantidade', indexperiodo: null, sortable: true, orderby: 'desc', class: 'numerico size130 border-left', style: '' },
            { nome: 'valor', visible: true, label: 'Valor Vendido', indexperiodo: null, sortable: true, orderby: null, class: 'numerico size130', style: '' },
            // { nome: 'participacao_qt_produtos_diferentes', visible: true, label: 'Participação Quantidade', indexperiodo: null, sortable: false, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'participacao_valor', visible: true, label: 'Participação Valor', indexperiodo: null, sortable: false, orderby: null, class: 'numerico size130', style: '' },
        ]

        let variacao = [
            // { nome: 'variacao_qt_produtos_diferentes', visible: true, label: 'Variação Quantidade', indexperiodo: null, sort: false, orderby: null, class: 'numerico size130 border-left', style: '' },
            { nome: 'variacao_valor', visible: true, label: 'Variação Valor', indexperiodo: null, sort: false, orderby: null, class: 'numerico size130', style: '' },
        ]

        for (var y = 0; y < this.dados.periodos.length; y++) {
            for (var x = 0; x < base.length; x++) {
                base[x].indexperiodo = y  //indexperiodo é utilizado para identificar a coluna de ordenacao dentro do periodo
            }
            this.colunas.push(...base)
            if (y > 0) 
                this.colunas.push(...variacao)
        }

        this.colunas.push({ nome: 'valor', visible: true, label: 'Valor Total', sortable: true, orderby: null, class: 'numerico size130', style: '' })

    },

    handleShowFiltro() {
      this.showfiltro = true;
    },

    filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.filial
      this.paramsFiltro.filtros[1].values = this.filtro.segmento
      this.paramsFiltro.filtros[2].values = this.filtro.grupocliente
      this.paramsFiltro.filtros[3].values = this.filtro.estado
      this.paramsFiltro.filtros[4].values = this.filtro.grupoestoque
      this.paramsFiltro.filtros[5].values = this.filtro.produto

      this.loadData();
    },

    filtroCancel() {
      this.showfiltro = false

    },

    async loadData(excel) {
      
      let url = "consulta/vendas/vendascliente";

      this.filtro.excel = excel;

      if (excel) 
        apiDownload2(this, url, this.filtro, "post")
      else {
        this.mounting = true
        const data = await apiORDSpost(this.$store, url, this.filtro, "post")
        if (data) {
          this.dados = data;
        } else {
          this.dados = {};
        }
      }
      this.montaColunas()
      this.mounting = false

    },
  },

  computed: {
    produtos: function () {
      if (!this.dados.clientes) 
        return []
      else 
        return this.dados.clientes
    },

    paramsChart: function () {
      return { chart: { type: "ColumnChart" }, values: this.chartValues }
    },

    chartValues: function () {
      if (!this.produtos || this.produtos.length == 0) 
        return []
    
      let title = ["Cliente"]
      let produto = []
      let tipoGrafico = 'Produtos Por Valor Vendido Em'

      for (var x = 0; x < this.dados.periodos.length; x++) {
          title.push(tipoGrafico + ' ' + this.dados.periodos[x].label)
      }

      let values = [title]

      for (var x = 0; x < this.produtos.length; x++) {
        produto = [this.produtos[x].nome_cliente]
        for (var y = 0; y < this.dados.periodos.length; y++) {
            produto.push(this.produtos[x][this.dados.periodos[y].nome].valor)
        }
        values.push(produto)
      }

      return values
    },
  },

  mounted() {

  },

  created() {
    this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
    this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())
    // this.filtro.periodos[0].data_inicio = "2020-02-01"
    // this.filtro.periodos[0].data_termino = "2020-08-17"

    this.loadData()
  },
}


</script>

<style>
table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative {
    color: white;
    background: indianred;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.consulta__total {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta__total_valor {
  font-size: 40px;
  display: block;
  line-height: normal;
}

.consulta__cifrao {
  font-size: 16px;
  display: block;
  line-height: normal;
}

</style>



// WEBPACK FOOTER //
// src/consultas/consulta-vendas-por-cliente.vue